import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import type { AxiosError } from 'axios';
import { apiClient } from '../services/apiClient';
import './AcceptInvitationPage.css'; // 同じスタイルを再利用

export function ConfirmEmailChangePage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'processing' | 'success' | 'error'>('processing');
  const [message, setMessage] = useState<string>('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('無効なトークンです');
      return;
    }

    confirmEmailChange();
  }, [token]);

  const confirmEmailChange = async () => {
    try {
      // apiClient 経由で叩く。dev は Vite proxy 経由、本番は VITE_BACKEND_ORIGIN を使う。
      // 以前は http://localhost:5001 がハードコードされていて本番で失敗していた。
      await apiClient.post(`/users/email/confirm/${token}`);
      setStatus('success');
      setMessage('メールアドレスが正常に変更されました。');

      // 3秒後にプロフィールページにリダイレクト
      setTimeout(() => {
        navigate('/profile');
      }, 3000);
    } catch (err) {
      console.error('Email change confirmation failed:', err);
      const axiosErr = err as AxiosError<{ error?: string }>;
      setStatus('error');
      setMessage(axiosErr?.response?.data?.error || 'メールアドレスの変更に失敗しました');
    }
  };

  if (status === 'processing') {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <div className="auth-card">
            <h1 className="auth-title">メールアドレスを変更中...</h1>
            <div className="loading-spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <div className="auth-card">
            <h1 className="auth-title">エラー</h1>
            <p className="auth-message error">
              {message}
            </p>
            <button
              type="button"
              className="btn-google"
              onClick={() => navigate('/profile')}
              style={{ marginTop: '24px' }}
            >
              プロフィールに戻る
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <h1 className="auth-title">メールアドレス変更完了</h1>
          <p className="auth-message">
            {message}
          </p>
          <p className="auth-description">
            3秒後にプロフィールページに移動します...
          </p>
          <button
            type="button"
            className="btn-google"
            onClick={() => navigate('/profile')}
            style={{ marginTop: '24px' }}
          >
            今すぐプロフィールに移動
          </button>
        </div>
      </div>
    </div>
  );
}
